import React from "react";
import Card from "./CardDashboard";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

const CardChannel = (props) => {
    const intl = useIntl();

    return (
        <Card 
            title={props.title}
            subtitle={intl.messages.by + ": " + props.creator}
            footer={props.footer} 
            bgColor="sky"
        > 
            <div className="card-extended">
                {props.children}
            </div>
        </Card>
    );
}

CardChannel.defaultProps = { 
    title: "",
    creator: "",
    footer: ""
}

CardChannel.propTypes = {
    title: PropTypes.string,
    creator: PropTypes.string,
    footer: PropTypes.string
}

export default (CardChannel);